import React, { useState } from "react";
import { SwitchOption } from "@src/lms/jelly/extensions/ui";
import { useIntl } from "react-intl";
import * as appConfig from "appConfig";
import styles from "./Slide1.module.scss";
import { messages } from "../../Introduction.messages";

export const Slide1: React.FC = () => {
  const { formatMessage } = useIntl();
  const [selectedOption, setSelectedOption] = useState(0);

  return (
    <div className={styles.slide1}>
      <img
        className={styles.speakersSetup}
        src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/introduction/speakers-setup.jpg`}
        alt="speakers-setup"
      />
      <div className={styles.content}>
        <img
          className={styles.contentImage}
          src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/introduction/slide1/${selectedOption + 1}.jpg`}
          alt="speakers-setup"
        />
        <SwitchOption
          onClick={setSelectedOption}
          activeItem={selectedOption}
          items={[
            {
              name: formatMessage(messages.slide1Option1),
            },
            {
              name: formatMessage(messages.slide1Option2),
            },
            {
              name: formatMessage(messages.slide1Option3),
            },
          ]}
        />
      </div>
    </div>
  );
};
